'use strict';

app.controller('LoginsCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$state',
    '$ngConfirm',
    'toaster',
    function($scope, $http, $translate, $state, $ngConfirm, toaster) {
        $scope.LOGINS_TAB = 1;
        $scope.GROUPS_TAB = 2;

        $scope.tab = $scope.LOGINS_TAB;

        $scope.changeTab = function(v) {
            $scope.resetForm();
            $scope.tab = v;
        };
        $scope.isTab = function(tab) {
            return $scope.tab === tab;
        };

        $scope.loading = false;
        $scope.expanded = false;
        $scope.user = '';

        $scope.form = {
            user: '',
            comment: '',
        };
        $scope.initialForm = angular.copy($scope.form);

        $scope.logins = [];
        $scope.groupsByClient = [];

        $scope.resetForm = function() {
            $scope.form = angular.copy($scope.initialForm);
        };
        $scope.afterFormAction = function() {
            $state.go($state.current, {}, { reload: true });
        };
        $scope.toggleExpandedForm = function() {
            $scope.expanded = !$scope.expanded;
        };
        $scope.isExpandedForm = function() {
            return $scope.expanded === true;
        };
        $scope.validatePassword = function(v) {
            var regex = new RegExp(
                '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{7,})'
            );
            return regex.test(v);
        };
        $scope.saveLogin = function() {
            var payload = $scope.form;

            if (!payload.user || !payload.comment) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant(
                        'general.toastr.error.form.validation.fill'
                    )
                );
                return false;
            }

            if (!$scope.validatePassword(payload.comment)) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('logins.toastr.error.password')
                );
                return false;
            }

            $http.post('/api/login/create', payload).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('logins.toastr.success.create')
                    );
                    $scope.afterFormAction();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('logins.toastr.error.create')
                    );
                }
            );
            return true;
        };
        $scope.updateLogin = function(login) {
            var payload = { loginId: login.loginId, user: login.user };
            if (!payload.user) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant(
                        'general.toastr.error.form.validation.fill'
                    )
                );
                return false;
            }

            $http.post('/api/login/update', payload).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant(
                            'general.toastr.success.form.action.update'
                        )
                    );
                    $scope.afterFormAction();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant(
                            'general.toastr.error.form.action.update'
                        )
                    );
                }
            );
            return true;
        };

        $scope.deleteLogin = function(id) {
            $http.post('/api/login/delete', { id: id }).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant(
                            'general.toastr.success.form.action.delete'
                        )
                    );
                    $scope.afterFormAction();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant(
                            'general.toastr.error.form.action.delete'
                        )
                    );
                }
            );
            return true;
        };
        $scope.beforeAssociateGroup = function(login) {
            var payload = {
                login: login.loginId,
                groups: login.groups.map(function(v) {
                    return v.groupId;
                }),
            };
            return payload;
        };
        $scope.associateWithGroups = function(l) {
            var payload = $scope.beforeAssociateGroup(l);
            $http.post('/api/login/associate', payload).then(function() {
                $scope.afterFormAction();
            });
            return true;
        };
        $scope.list = function() {
            $scope.loading = true;
            $http.get('/api/login/list').then(
                function(response) {
                    var data = response.data.data;

                    $scope.logins = data.logins;
                    $scope.groupsByClient = data.groups;

                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };
        $scope.init = function() {
            $scope.list();
        };
        $scope.init();

        $scope.deleteLoginConfirmation = function(login) {
            var user = login.user + '@' + login.code;
            $ngConfirm({
                title: $translate.instant('general.confirm.delete.title'),
                content:
                    $translate.instant('general.confirm.delete.content') +
                    '<b> (' +
                    user +
                    ') </b>',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-trash pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.delete.yes'),
                        btnClass: 'btn-danger',
                        action: function(scope) {
                            scope.deleteLogin(login.loginId);
                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.delete.no'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };
    },
]);
